// Filename: uiarticlesub.js
// Timestamp: 2017.11.19-13:42:01 (last modified)
// Author(s): bumblehead <chris@bumblehead.com>

import uiarticleprev from './uiarticleprev.js'

const xvnode = (sess, cfg, graph, node, subj, pg) => {
  const { div } = cfg.h(pg, node)
  const title = subj.title
  const labeltertiary = subj.labeltertiary

  return title && (
    div('.:ui', [
      div('.:ui-label-tertiary', labeltertiary),
      uiarticleprev.xvnode(sess, cfg, graph, node, subj)
    ])
  )
}

export default {
  type: 'uiarticlesub',
  xvnode
}
